import { useMemo } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, CartesianGrid } from "recharts";

const COLORS = { passed: "#059669", failed: "#dc2626", incomplete: "#94a3b8" };

export function PerformanceCharts({ rows }) {
  const byModule = useMemo(() => {
    const m = {};
    for (const r of rows) {
      const k = r.module_name || "-";
      m[k] = m[k] || { module: k, sum: 0, n: 0, passed: 0, failed: 0, incomplete: 0 };
      if (r.final_score != null) { m[k].sum += r.final_score; m[k].n += 1; }
      m[k][r.complete ? (r.passed ? "passed" : "failed") : "incomplete"] += 1;
    }
    return Object.values(m).map((x) => ({ ...x, avg: x.n ? Math.round(x.sum / x.n) : 0 })).sort((a, b) => a.module.localeCompare(b.module));
  }, [rows]);
  const status = useMemo(() => {
    const c = { passed: 0, failed: 0, incomplete: 0 };
    for (const r of rows) c[r.complete ? (r.passed ? "passed" : "failed") : "incomplete"] += 1;
    return [{ name: "Lulus", key: "passed", value: c.passed }, { name: "Belum lulus", key: "failed", value: c.failed }, { name: "Belum lengkap", key: "incomplete", value: c.incomplete }];
  }, [rows]);
  const assessed = rows.filter((r) => r.final_score != null);
  const overall = assessed.length ? Math.round(assessed.reduce((a, r) => a + r.final_score, 0) / assessed.length) : null;
  if (!rows.length) return null;
  return (
    <div className="grid gap-4 lg:grid-cols-3 mb-4" data-testid="performance-charts">
      <div className="surface p-4 lg:col-span-2">
        <p className="font-heading font-bold text-sm mb-1">Rata-rata nilai akhir per modul</p>
        <p className="text-[11px] text-slate-400 mb-2">{assessed.length} penilaian · rata-rata keseluruhan <b className="text-slate-700">{overall ?? "-"}</b></p>
        <div className="h-56">
          <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={0} initialDimension={{ width: 320, height: 200 }}>
            <BarChart data={byModule} margin={{ left: 0, right: 8, top: 4, bottom: 4 }}><CartesianGrid strokeDasharray="3 3" vertical={false} /><XAxis dataKey="module" tick={{ fontSize: 10 }} interval={0} angle={-15} textAnchor="end" height={50} /><YAxis domain={[0, 100]} tick={{ fontSize: 10 }} width={28} /><Tooltip formatter={(v, n) => [v, n === "avg" ? "Rata-rata" : n]} /><Bar dataKey="avg" name="Rata-rata" radius={[4, 4, 0, 0]} isAnimationActive={false}>{byModule.map((d) => <Cell key={d.module} fill={d.avg >= 70 ? COLORS.passed : d.avg > 0 ? "#f59e0b" : COLORS.incomplete} />)}</Bar></BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="surface p-4">
        <p className="font-heading font-bold text-sm mb-1">Status kelulusan</p>
        <p className="text-[11px] text-slate-400 mb-2">{rows.length} baris siswa × modul</p>
        <div className="h-40">
          <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={0} initialDimension={{ width: 200, height: 160 }}>
            <PieChart><Pie data={status} dataKey="value" nameKey="name" innerRadius={40} outerRadius={65} isAnimationActive={false}>{status.map((s) => <Cell key={s.key} fill={COLORS[s.key]} />)}</Pie><Tooltip /></PieChart>
          </ResponsiveContainer>
        </div>
        <div className="flex flex-wrap gap-2 text-[11px]">{status.map((s) => <span key={s.key} className="inline-flex items-center gap-1" data-testid={`status-${s.key}`}><span className="h-2.5 w-2.5 rounded-full" style={{ background: COLORS[s.key] }} />{s.name}: <b>{s.value}</b></span>)}</div>
      </div>
    </div>
  );
}
